<span class="guide-tooltip-wrapper" [title]="tooltipText" (click)="openGuide()">
  <mat-icon class="guide-icon">help_outline</mat-icon>
</span>